__webpack_require__.p = "https://utpl.edu.ec/seminario-economia/";